var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29289 7.39329C2.10536 7.58654 2 7.84865 2 8.12195V16.9695C2 17.5386 2.44772 18 3 18H9C9.55229 18 10 17.5386 10 16.9695V8.12196C10 7.84865 9.89464 7.58654 9.70711 7.39329L6.70711 4.30182C6.31658 3.89939 5.68342 3.89939 5.29289 4.30182L2.29289 7.39329ZM5 7.69527C5 7.12615 5.44772 6.66478 6 6.66478C6.55229 6.66478 7 7.12615 7 7.69527C7 8.26439 6.55229 8.72576 6 8.72576C5.44772 8.72576 5 8.26439 5 7.69527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.9695V8.12195C11.5 7.97798 11.4883 7.83525 11.4655 7.69511H14L17.2929 4.30182C17.6834 3.89939 18.3166 3.89939 18.7071 4.30182L21.7071 7.39329C21.8946 7.58654 22 7.84865 22 8.12195V16.9695C22 17.5386 21.5523 18 21 18H11.292C11.4258 17.6844 11.5 17.3359 11.5 16.9695ZM17 7.69527H19C19 7.12615 18.5523 6.66478 18 6.66478C17.4477 6.66478 17 7.12615 17 7.69527Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.ea7ecd44c39cbca89e349155dd9dd83a.svg";
export { ForwardRef as ReactComponent };